<div style="margin-top: 3px">
    <mat-chip-list #chipList aria-label="Tag display">
        <mat-chip *ngFor="let tag of tags" [selectable]="true" [removable]="false">
            {{ tag.Name }}
        </mat-chip>
    </mat-chip-list>
</div>
